import { render, staticRenderFns } from "./PostSimulation.vue?vue&type=template&id=72c93f3e&"
import script from "./PostSimulation.vue?vue&type=script&lang=js&"
export * from "./PostSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports